import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TabItem } from '../../models/common.model';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-tab-navigation',
  imports: [NgClass, NgIf],
  templateUrl: './tab-navigation.component.html',
  styleUrl: './tab-navigation.component.scss',
})
export class TabNavigationComponent {
  @Input() tabs: TabItem[] = [];
  @Input() selectedTab!: string;
  @Output() tabChange = new EventEmitter<string>();

  selectTab(tabValue: string) {
    this.tabChange.emit(tabValue);
  }
}
